import { Component } from '@angular/core';

/** Coquille hôte : barre de titre (vente) + détail fournisseur bibliothèque. */
@Component({
  selector: 'app-fournisseur-detail-shell',
  template: '<app-title-section></app-title-section><router-outlet></router-outlet>'
})
export class FournisseurDetailShellComponent {}
